module.exports = __webpack_public_path__ + "static/6-d4e4aef854263dbeb2845e23018324c6.jpeg";